import { render, staticRenderFns } from "./PriceTotal.vue?vue&type=template&id=7eb4130c&"
import script from "./PriceTotal.vue?vue&type=script&lang=js&"
export * from "./PriceTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports